import {
  GroupBulkButtonComponents,
  GroupTableBulkName,
} from "@components/common/faro-table/faro-table-types";
import { BulkExportGroups } from "@components/table/groups/bulk-actions/bulk-export-groups";
import { GroupTypes } from "@custom-types/group-types";
import { useShouldShowBulkAction } from "@hooks/table/use-should-show-bulk-action";
import { useAppSelector } from "@store/store-helper";
import { fetchingGroupsFlagsSelector } from "@store/groups/groups-selector";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { useMemo } from "react";

interface Props {
  /** List of groups to show in table */
  groups: GroupTypes[];
}

/** List all the bulk action components for group table */
export function useGroupsPageBulkActions({
  groups,
}: Props): GroupBulkButtonComponents {
  const selectedEntities = useAppSelector(selectedEntitiesSelector("groups"));
  const { isFetchingGroups } = useAppSelector(fetchingGroupsFlagsSelector);
  const isAnyRowSelected = selectedEntities.length !== 0;

  const allowedButtonsBasedOnRowSelection: GroupTableBulkName[] =
    useMemo(() => {
      const allowedButtons: GroupTableBulkName[] = ["export"];

      return allowedButtons;
    }, []);

  const { shouldShowBulkButtons } = useShouldShowBulkAction({
    allowedButtonsBasedOnRowSelection,
  });

  /** Determine whether to show the export button */
  const shouldShowExportButton =
    shouldShowBulkButtons("export") && (isFetchingGroups || groups.length > 0);

  return {
    export: shouldShowExportButton ? (
      <BulkExportGroups
        selectedGroups={isAnyRowSelected ? selectedEntities : groups}
        areEntitiesSelected={isAnyRowSelected}
      />
    ) : null,
  };
}
